import React from "react";
import { Box, CircularProgress, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "../../../../../components/CancelModal/CancelModal.module.css";
import { useSelector } from "react-redux";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "95%",
    sm: "50%",
    lg: 430,
    xl: 430,
    md: 430,
  },
  bgcolor: "background.paper",
  border: "none",
  boxShadow:
    "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
  borderRadius: "12px",
  p: "20px",
  zIndex: 9999999,
};

function ResendPaymentLinkPopup(props: any) {
  const { open, onClose, noButtonClick, yesButtonClick } = props;

  const { sendPaymentLinkLoading } = useSelector((state: any) => state.nurture);
  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ zIndex: "99999999" }}
      >
        <Box sx={style}>
          <div>
            <div onClick={onClose} className={styles.closeModalButton}>
              <CloseIcon />
            </div>
            <div className={styles.modalTitle}>
              Are you sure you want to resend the Payment Link?
            </div>
            <div className={styles.modalDes}>
              It will Invalidate the previous link.
            </div>
            <div className={styles.buttonSection}>
              <button
                onClick={noButtonClick}
                className={styles.noButton}
                style={{ flexBasis: "100%" }}
              >
                No
              </button>
              <button
                onClick={yesButtonClick}
                style={{
                  borderRadius: "4px",
                  background: "#11C89B",
                  color: "#fff",
                  fontSize: "16px",
                  fontWeight: "500",
                  border: "none",
                  cursor: "pointer",
                  flexBasis: "100%",
                }}
                disabled={sendPaymentLinkLoading}
              >
                {sendPaymentLinkLoading ? (
                  <CircularProgress size={20} color={"inherit"} />
                ) : (
                  "Yes"
                )}
              </button>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default ResendPaymentLinkPopup;
